// extracted by mini-css-extract-plugin
module.exports = {"navbar":"App_navbar__1de1s","footer":"App_footer__2B6Sm"};